import { ISelectOption } from '../interfaces/select-option.interface';

export const CONTENT_ALIGNMENT_OPTIONS: ISelectOption[] = [
  { key: 'start', name: 'Left' },
  { key: 'center', name: 'Center' },
  { key: 'end', name: 'Right' },
];
